import React from "react";
import usePatchHook from "../../customHooks/usePatchHook";
import APIS from "../../constant/EndPoint";
import { useParams } from "react-router-dom";
import loadable from "@loadable/component";
import useGetHook from "../../customHooks/useGetHook";
import { tw } from "@careinfo/tailwind";
import CreateIcon from "../../Icons/CreateIcon";
import Spinner from "../../components/Reusable/Spinner";
import usePostHook from "../../customHooks/usePostHook";
const EditExpenseNoteComponent = loadable(
  () => import("../../components/ExpenseNote/SwitchTab")
);

const EditExpenseNote = () => {
  const { id } = useParams();
  const { mutateAsync, isLoading } = usePatchHook({
    queryKey: ["expense-note", `expense-note-${id}`],
    navigateURL: "/",
  });
  const { mutateAsync: toggleAsync, isPostLoading: isMarkasDoneloading } =
    usePostHook({
      queryKey: ["expense-note", `expense-note-${id}`],
      navigateURL: "/",
    });

  const { data, isLoading: isDataLoading } = useGetHook({
    queryKey: ["expense-note", `expense-note-${id}`],
    url: `${APIS.EXPENSE_NOTE}${id}/`,
    params: {},
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.EXPENSE_NOTE}${id}/`;
    const formatContact = (number) => {
      if (!number) return null;
      return number.startsWith("+977") ? number : `+977${number}`;
    };
    let formData = {
      ...values,
      receiver_phone_number: formatContact(values?.receiver_phone_number),
    };
    try {
      const res = await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  const handleMarkAsDone = async (values: any, setError: any) => {
    const url = `${APIS.EXPENSE_NOTE}${id}/toggle-active/`;
    let formData = {};
    try {
      const res = await toggleAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>
          Edit Expense Note
        </span>
      </div>
      {isDataLoading ? (
        <Spinner />
      ) : (
        <EditExpenseNoteComponent
          handleEdit={handleEdit}
          isLoading={isLoading}
          handleMarkAsDone={handleMarkAsDone}
          isMarkasDoneloading={isMarkasDoneloading}
          data={data}
          id={id}
        />
      )}
    </>
  );
};

export default EditExpenseNote;
